import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui";

export const CTASection: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section
      id="contact"
      className="relative py-16 md:py-24 bg-[#f1ede7]"
      aria-labelledby="cta-heading"
    >
      {/* CTA Card - White background, logo prominent */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-xl shadow-tiber-900/10 border border-tiber-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 p-8 md:p-10 lg:p-12">
            {/* Logo - White background container */}
            <div className="shrink-0 order-first lg:order-0">
              <div
                className="w-32 h-32 md:w-40 md:h-40 lg:w-44 lg:h-44 rounded-xl bg-white flex items-center justify-center p-5 ring-2 ring-tiber-100 shadow-inner"
                aria-hidden="true"
              >
                <img
                  src="/images/brand/lawgentia-logo.png"
                  alt="Lawgentia"
                  className="w-full h-full object-contain"
                  draggable={false}
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 text-center lg:text-left min-w-0">
              <h2
                id="cta-heading"
                className="text-xl sm:text-2xl md:text-3xl font-display font-bold text-tiber-900 mb-3 md:mb-4 leading-tight"
              >
                {t("landing.cta.title")}
              </h2>

              <p className="text-tiber-700 text-base md:text-lg mb-6 md:mb-8 leading-relaxed max-w-xl mx-auto lg:mx-0">
                {t("landing.cta.description")}
              </p>

              {/* CTAs - 44px min touch targets */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => navigate("/onboarding/select-type")}
                  className="min-h-[44px] sm:min-h-[48px] px-6 transition-all duration-200 hover:shadow-lg"
                >
                  {t("landing.cta.primaryAction")}
                </Button>
                <Button
                  variant="secondary"
                  size="lg"
                  onClick={() => {
                    const pricingSection = document.getElementById("pricing");
                    pricingSection?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="min-h-[44px] sm:min-h-[48px] px-6 border-2 border-tiber-600 text-tiber-700 hover:bg-tiber-50 transition-colors duration-200"
                >
                  {t("landing.cta.secondaryAction")}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
